import React from "react";
import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import CustomButton from "components/CustomButton";

const StepsSection = () => {
  const steps = [
    {
      img: "https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2Fcardexmedicopasouno%20medium.png?alt=media&token=f7145667-345a-4360-813b-3765feded404",
      title: "1. Inicia sesión con tu CURP",
      text: "Accede de forma rápida y segura utilizando tu CURP para comenzar la creación de tu expediente médico digital.",
      opacity: 1,
      visible: true,
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2Fcardexmedicopasodosmedium.png?alt=media&token=c80d9d37-e441-482c-905b-7d701ba25cb1",
      title: "2. Completa tu formulario inicial",
      text: "Proporciona información esencial como enfermedades crónicas, peso, edad, estatura y otros datos relevantes para tu perfil clínico.",
      opacity: 1,
      visible: true,
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2Fcardexmedicopasotresmedium.png?alt=media&token=5c0fd11d-9b6b-4c89-bfaa-b3922ee44361",
      title: "3. Registra tu estilo de vida",
      text: "Añade información sobre tus hábitos diarios, como actividad física, consumo de alimentos y bienestar general.",
      opacity: 1,
      visible: true,
    },
    {
      img: "https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2Fcardexmedicopasocuatromedium.png?alt=media&token=954d80be-fd9a-4106-9ceb-4d802a04265a",
      title: "4. Incluye antecedentes médicos familiares",
      text: "Agrega datos hereditarios relevantes que contribuyan a una evaluación médica integral y personalizada.",
      opacity: 1,
      visible: true,
    },
  ];


  return (
    <Box sx={{ px: 4, py: 8, }}>
      <Grid container spacing={4}>
        {steps.map((item, index) => (
          <Grid 
            item 
            xs={12} 
            md={4} 
            key={index}   
            data-aos="fade-up"            // 👈 Aquí se aplica la animación
            data-aos-delay={index * 200} // animación escalonada
          >
            <Paper
              elevation={0}
              sx={{
                p: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                borderRadius: 0,
                backgroundColor: '#f5f5f5' 
              }}
              >
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',  // ✅ centers image horizontally
                  alignItems: 'center',      // ✅ centers image vertically
                  mb: 2,
                }}
              >
                <Box
                  component="img"
                  src={item.img}
                  alt={item.title}
                  sx={{
                    width: 256,               // ✅ make it a little bigger and balanced
                    height: 256,
                    objectFit: 'contain',    // ✅ keeps aspect ratio
                    display: 'block',        // ✅ prevents inline space bugs
                  }}
                />
              </Box>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                {item.title}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                {item.text}
              </Typography>
            </Paper>
          </Grid>
        ))}
         <Grid 
            item 
            xs={12} 
            md={8} 
            key={'custom-button'}   
          >
            <Paper
              elevation={0}
              sx={{
                p: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', // ✅ centra vertical
                alignItems: 'center',     // ✅ centra horizontal
                borderRadius: 0,
                backgroundColor: '#f5f5f5' 
              }}
              >
           <CustomButton></CustomButton>
            </Paper>
          </Grid>
      </Grid>
    </Box>
  )
};




export default StepsSection;
